import React, { Fragment, useState } from 'react';
import Counter from '../../../components/counter';
import { useCart } from '../../../core/hooks';
import { CartItem } from '../../../models/order-models';
import { InActiveUserPopup } from '../../../components/inactive-user-popup';

export const CartCounter = (props: { cartItem: CartItem , cartUserStatus?: string}) => {
  const item = props.cartItem;
  const { updateQuantity } = useCart();
  const [openModal, setOpenModal] = useState<{ isOpen?: boolean; msg?: string; }>({ isOpen: false });

  const onClose = () => {
    setOpenModal({});
  }

  const handleUpdateQuantity = async (items, cnt) => {
    const response = await updateQuantity(items, cnt);
    if (response?.errorMsg?.includes("inactive") && response?.response === 'Failure') {
      setOpenModal({
        isOpen: true,
        msg: response?.errorMsg,
      });
    }
  };
  return (
    <Fragment>
      <Counter
        isLoading={item.isLoading}
        value={item?.orderItemQuantity!}
        onChange={(count) => {
          handleUpdateQuantity(item, count);
        }}
        isProductAddedToCart={true}
        className="numberField"
        updateValue={false}
        defaultValue={item.orderItemQuantity}
        disabled={false}
        userStatus={props?.cartUserStatus}
      />
      <InActiveUserPopup isOpen={openModal.isOpen} content={openModal.msg || ''} onClose={() => onClose()} />
    </Fragment>

  );
};
